(() => {
  if (window.PCHeader) { window.PCHeader.init(); return; }
  let dispose;
  function init() {
    dispose?.();
    const header = document.querySelector('[data-pc-header]');
    const shell = header?.closest('[data-pc-header-shell]');
    const burger = document.getElementById('pcBurger');
    const menu = document.getElementById('pcMobileMenu');
    if (!header || !shell || !burger || !menu) return;
    const abort = new AbortController(), signal = abort.signal;
    let open = false, oldOverflow = '', background = [], frame = 0;
    const mobile = matchMedia('(max-width: 1100px)');
    let active = false;
    const nav = [...header.querySelectorAll('a[data-pc-scroll]')];
    const marked = [...shell.querySelectorAll('a[data-pc-scroll]')];
    const sync = () => {
      frame = 0;
      if (!active) return;
      // Collect every layout measurement before changing styles or attributes.
      const height = header.offsetHeight;
      const bottom = open ? header.getBoundingClientRect().bottom + 'px' : null;
      const scrolled = String(scrollY > 24);
      let current;
      for (const link of nav) {
        const target = document.getElementById(link.hash.slice(1));
        if (target && target.getBoundingClientRect().top <= height + 100) current = link.hash;
      }
      const value = height + 'px';
      if (document.documentElement.style.getPropertyValue('--pc-header-height') !== value) document.documentElement.style.setProperty('--pc-header-height', value);
      if (header.dataset.scrolled !== scrolled) header.dataset.scrolled = scrolled;
      if (bottom !== null && menu.style.top !== bottom) menu.style.top = bottom;
      marked.forEach(link => {
        const selected = current && link.hash === current;
        if (selected) { if (link.getAttribute('aria-current') !== 'location') link.setAttribute('aria-current', 'location'); }
        else if (link.hasAttribute('aria-current')) link.removeAttribute('aria-current');
      });
    };
    const schedule = () => { if (active && !frame) frame = requestAnimationFrame(sync); };
    function close(restoreFocus = false) {
      if (!open) return;
      open = false;
      shell.removeAttribute('role'); shell.removeAttribute('aria-modal'); shell.removeAttribute('aria-label');
      header.dataset.menuOpen = 'false';
      burger.classList.remove('open'); burger.setAttribute('aria-expanded', 'false'); burger.setAttribute('aria-label', burger.dataset.labelOpen);
      menu.classList.remove('open'); menu.setAttribute('aria-hidden', 'true'); menu.inert = true;
      document.body.classList.remove('pc-mobile-nav-open');
      document.body.style.overflow = oldOverflow;
      background.forEach(([el, inert]) => { el.inert = inert; }); background = [];
      if (restoreFocus) burger.focus({preventScroll:true});
    }
    function markBackground() {
      for (let branch = shell; branch.parentElement && branch !== document.body; branch = branch.parentElement) {
        for (const sibling of branch.parentElement.children) {
          if (sibling !== branch && sibling instanceof HTMLElement && !sibling.matches('script,style,link,template') && !background.some(([el]) => el === sibling)) {
            background.push([sibling, sibling.inert]); sibling.inert = true;
          }
        }
      }
    }
    function show() {
      open = true; oldOverflow = document.body.style.overflow;
      shell.setAttribute('role', 'dialog'); shell.setAttribute('aria-modal', 'true'); shell.setAttribute('aria-label', shell.dataset.menuLabel);
      header.dataset.menuOpen = 'true';
      burger.classList.add('open'); burger.setAttribute('aria-expanded', 'true'); burger.setAttribute('aria-label', burger.dataset.labelClose);
      menu.inert = false; menu.classList.add('open'); menu.setAttribute('aria-hidden', 'false');
      document.body.classList.add('pc-mobile-nav-open');
      menu.scrollTop = 0;
      background = [];
      markBackground();
      // 2 Nov 2026: on the default homepage this controller can run while the page is still parsing, so the menu can open
      // before later page content exists. Mark that content inert too once parsing ends, if the menu is still open.
      if (document.readyState === 'loading') {
        const watch = new MutationObserver(() => { if (open) markBackground(); else watch.disconnect(); });
        for (let branch = shell; branch.parentElement && branch !== document.body; branch = branch.parentElement) watch.observe(branch.parentElement, {childList:true});
        document.addEventListener('DOMContentLoaded', () => { watch.disconnect(); if (open) markBackground(); }, {once:true, signal});
        signal.addEventListener('abort', () => watch.disconnect(), {once:true});
      }
      document.body.style.overflow = 'hidden'; sync();
      menu.querySelector('a')?.focus({preventScroll:true});
    }
    burger.addEventListener('click', () => open ? close(true) : show(), {signal});
    shell.addEventListener('click', e => { if (e.target.closest('a')) close(true); }, {signal});
    document.addEventListener('keydown', e => {
      if (!open) return;
      if (e.key === 'Escape') { e.preventDefault(); close(true); return; }
      if (e.key !== 'Tab') return;
      const links = [...shell.querySelectorAll('a[href],button:not([disabled])')].filter(el => el.getClientRects().length && !el.closest('[inert]'));
      const first = links[0], last = links.at(-1);
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }, {signal});
    document.addEventListener('focusin', e => {
      if (open && !shell.contains(e.target)) menu.querySelector('a')?.focus({preventScroll:true});
    }, {signal});
    document.addEventListener('pc:chatopen', () => close(true), {signal});
    document.addEventListener('click', e => {
      const link = e.target.closest('[data-pc-scroll]');
      if (!link || !(header.contains(link) || menu.contains(link))) return;
      const id = link.hash.slice(1);
      const target = document.getElementById(id);
      if (!target) {
        // 2 Nov 2026: on the default homepage the menu works while the page is still parsing. If the chapter is not parsed
        // yet, hold the jump until it is, then use the same offset scroll and heading focus as a normal tap.
        if (!id || document.readyState !== 'loading' || link.pathname !== location.pathname) return;
        e.preventDefault(); close();
        document.addEventListener('DOMContentLoaded', () => { const later = document.getElementById(id); if (later) jump(later); }, {once:true, signal});
        return;
      }
      e.preventDefault(); close();
      jump(target);
    }, {signal});
    function jump(target) {
      const top = target.getBoundingClientRect().top + scrollY - header.offsetHeight - 18;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      scrollTo({top, behavior: reduced || Math.abs(top-scrollY) > innerHeight*1.5 ? 'auto' : 'smooth'});
      // Keyboard navigation lands at the requested section instead of in a closed menu.
      const focusTarget = target.matches('h1,h2,h3') ? target : target.querySelector('h1,h2,h3') || target;
      if (!focusTarget.hasAttribute('tabindex')) { focusTarget.setAttribute('tabindex','-1'); focusTarget.addEventListener('blur',()=>focusTarget.removeAttribute('tabindex'),{once:true}); }
      focusTarget.focus({preventScroll:true});
    }
    const resize = new ResizeObserver(schedule);
    function activate() {
      active = mobile.matches;
      cancelAnimationFrame(frame); frame = 0;
      resize.disconnect();
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      if (active) {
        window.addEventListener('scroll', schedule, {passive:true});
        window.addEventListener('resize', schedule, {passive:true});
        resize.observe(header); schedule();
      } else {
        const restoreFocus = open && shell.contains(document.activeElement);
        close();
        document.documentElement.style.removeProperty('--pc-header-height');
        if (restoreFocus) document.querySelector('[data-ph1-bar] .ph1-cta')?.focus({preventScroll:true});
      }
    }
    mobile.addEventListener('change', activate);
    menu.inert = true; activate();
    dispose = () => {
      close(); abort.abort(); resize.disconnect(); cancelAnimationFrame(frame);
      mobile.removeEventListener('change', activate);
      window.removeEventListener('scroll', schedule); window.removeEventListener('resize', schedule);
    };
  }
  window.PCHeader = {init, destroy: () => dispose?.()};
  document.addEventListener('shopify:section:load', e => { if (e.target.querySelector('[data-pc-header]')) init(); });
  document.addEventListener('shopify:section:unload', e => { if (e.target.querySelector('[data-pc-header]')) dispose?.(); });
  init();
})();
